import React, { useCallback, useState } from "react";
import { Dialog, ThemeProvider } from "@mui/material";
import { VPUITheme } from "../../../../../common/theme/vpui-theme";
import { OperationDataReportForm } from "./operation-data-report-form";
import { OperationDataReportSuccess } from "./operation-data-report-success";
import { useTimeout } from "../../../../../common/hooks/use-timeout";
import { notificationModel } from "../../../../../common/component/notifications/notification-model";
import { t } from "i18next";

import "./style.scss";

interface IOperationDataValidationReportPopupProps {
    operation: string;
    onClose: () => void;
}

export const OperationDataReportPopup = (props: IOperationDataValidationReportPopupProps) => {
    const [ticketNumber, setTicketNumber] = useState<string | undefined>(undefined);

    const handleFormSuccess = useCallback((id: string) => setTicketNumber(id), []);
    const handleFormClose = useCallback(() => {
        notificationModel.addSuccessMessage(t("components.operationDataValidation.report.popup.successNotification", {
            ticketNumber,
        }));

        props.onClose();
    }, [ticketNumber, props.onClose]);
    useTimeout(handleFormClose, 3500, !!ticketNumber);

    return <ThemeProvider theme={VPUITheme}>
        <Dialog open={true} fullWidth onClose={props.onClose} classes={{ paper: "operation-report" }}>
            {!ticketNumber ?
                <OperationDataReportForm {...props} onSuccess={handleFormSuccess} /> :
                <OperationDataReportSuccess ticketNumber={ticketNumber} />}
        </Dialog>
    </ThemeProvider>;
};
